/**
 * A simple wrapper around aptrinsic('track', eventName, eventDetails)
 * Please keep this function close to the vanilla!
 *
 * ref: https://support.gainsight.com/PX/API_for_Developers/02Usage_of_Different_APIs/Use_Custom_Event_API
 *
 * @param eventName name of the event
 * @param eventDetails details of the event.
 *      The value must of string, number or boolean. ISO 8601 date strings understood by gainsight.
 *      Using other data types may result in undefined bahaviour from gainsight.
 */

import {COMMON_ANALYTICS_ACTIONS, CommonAnalyticsActions} from 'constants/AnalyticsConstants';

const GAINSIGHT_EVENT_WHITELIST = new Set([
  COMMON_ANALYTICS_ACTIONS[CommonAnalyticsActions.SUBMITTED_CREATE_ANALYSIS].action,
  COMMON_ANALYTICS_ACTIONS[CommonAnalyticsActions.SUBMITTED_BETA_REQUEST].action,
]);

function trackCustomEvent(
  eventName: string,
  eventDetails: Record<string, string | number | boolean | null | undefined>
): void {
  if (window.aptrinsic) {
    window.aptrinsic('track', eventName, eventDetails);
  } else {
    // eslint-disable-next-line no-console
    console.warn('Gainsight not enabled');
  }
}

const gainsight = {trackCustomEvent, GAINSIGHT_EVENT_WHITELIST};

export default gainsight;
